import React from 'react'
// import {makeStyles} from '@material-ui/core/styles'
import {Alert, AlertTitle} from '@material-ui/lab'

// const useStyles = makeStyles(theme => ({
//   root: {
//     width: '100%',
//     '& > * + *': {
//       marginTop: theme.spacing(2),
//     },
//   },
// }))

export default function StepPaymentError(props) {
  // const classes = useStyles()
  const {title = 'Errore', message = 'Errore generico'} = props

  return (
    // <div className={classes.root}>
    <Alert severity="error">
      <AlertTitle>{title}</AlertTitle>
      {message}
    </Alert>
    // </div>
  )
}
